<template>
  <!-- 订单管理-订单管理 -->
  <div>
    <div v-if="isCom">
      <div v-if="queryData.length === 0">
        暂无数据
      </div>
      <template
        v-else>
        <Table
          :columns="comColumn"
          :loading="loading"
          :data="queryData"
          border
          ref="dataTable"
        >
          <template slot-scope="{row}" slot="couponsStatus">
            <OrderStatus :node-state="row.nodeState" :tag-info="nodeState"></OrderStatus>
          </template>
          <template slot-scope="{row}" slot="writeOffStatus">
            <OrderStatus v-show="row.nodeState!==2" :node-state="row.notifyState" :tag-info="notifyState"></OrderStatus>
          </template>
          <template slot-scope="{row}" slot="couponsTime">
            {{ row.createDate | formatTime }}111
          </template>
          <template slot-scope="{row}" slot="action">
            <Button
              v-if="row.useState"
              type="text"
              class="text-link"
              size="small"
              icon="md-pause"
              @click="statusItem(row)"
            >暂停
            </Button>
          </template>
        </Table>
        <Row>
          <Col :md="24" class="pagination">
            <Page
              :total="totalPage"
              :page-size="pageSize"
              :current="pageNum"
              :disabled="loading"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              :page-size-opts="[10, 20, 50, 100]"
              show-elevator show-sizer show-total/>
          </Col>
        </Row>
      </template>
    </div>
    <div v-else class="app-content">
      <AppPageTitle></AppPageTitle>
      <Content class="app-content__main">
        <Form ref="formValidate" :model="formValidate" :label-width="120">
          <Row>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="代理商订单号:" prop="outTradeNo">
                <Input v-model.trim="formValidate.outTradeNo" placeholder="请输入" clearable maxlength="50"/>
              </FormItem>
            </Col>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="用户:" prop="account">
                <Input v-model.trim="formValidate.account" placeholder="请输入" clearable maxlength="50"/>
              </FormItem>
            </Col>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="供应商:" prop="supplierId">
                <Select v-model="formValidate.supplierId" clearable style="width: 100%;">
                  <Option v-for="item in supplierList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="订单状态:" prop="supplierId">
                <Select v-model="formValidate.nodeState" clearable style="width: 100%;">
                  <Option v-for="item in nodeState" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="商品名称:" prop="commodityName">
                <Input v-model.trim="formValidate.commodityName" placeholder="请输入" clearable maxlength="50"/>
              </FormItem>
            </Col>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="商品编号:" prop="commodityId">
                <Input v-model.trim="formValidate.commodityId" placeholder="请输入" clearable maxlength="50"/>
              </FormItem>
            </Col>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="供应商商品编号:" prop="commodityNo">
                <Input v-model.trim="formValidate.commodityNo" placeholder="请输入" clearable maxlength="50"/>
              </FormItem>
            </Col>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="发券时间:">
                <DatePicker
                  type="datetimerange"
                  v-model="sendingData"
                  format="yyyy-MM-dd HH:mm:ss"
                  split-panels
                  placeholder="请选择"
                  style="width:100%"/>
              </FormItem>
            </Col>
            <Col :md="8" :sm="12" :xs="24">
              <FormItem label="核销时间:">
                <DatePicker
                  type="datetimerange"
                  v-model="usageData"
                  format="yyyy-MM-dd HH:mm:ss"
                  split-panels
                  placeholder="请选择"
                  style="width:100%"/>
              </FormItem>
            </Col>
            <Col :md='24' class="text-right">
              <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
              <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
            </Col>
          </Row>
        </Form>
        <Row>
          <Col :md='24' style="margin-bottom: 20px">
            <Button
              icon="md-download"
              style="margin-right: 8px"
              :disabled="!queryData.length"
              @click="exportOrder"
            >导出
            </Button>
            <Button
              type="info"
              style="margin-right: 8px"
              :disabled="!queryData.length"
              @click="manualOrder()"
            >补发
            </Button>
          </Col>
        </Row>
        <Table
          :span-method="handleSpan"
          :columns="queryColumn"
          :loading="loading"
          :data="queryData"
          border
          ref="dataTable"
          @on-selection-change="selectChangeHandler"
        >
          <template slot-scope="{row}" slot="couponsStatus">
            <OrderStatus :node-state="row.nodeState" :tag-info="nodeState"></OrderStatus>
          </template>
          <template slot-scope="{row}" slot="writeOffStatus">
            <OrderStatus v-show="row.nodeState!==2" :node-state="row.notifyState" :tag-info="notifyState"></OrderStatus>
          </template>
          <template slot-scope="{row}" slot="couponsTime">
            {{ row.createDate | formatTime }}
          </template>
          <template slot-scope="{row}" slot="action">
            <Button
              v-if="row.useState"
              type="text"
              class="text-link"
              size="small"
              icon="md-pause"
              @click="statusItem(row)"
            >暂停
            </Button>
          </template>
        </Table>
        <Row>
          <Col :md="24" class="pagination">
            <Page
              :total="totalPage"
              :page-size="pageSize"
              :current="pageNum"
              :disabled="loading"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              show-elevator show-sizer show-total/>
          </Col>
        </Row>
      </Content>
      <ExportFile ref="exportFile"/>
      <Modal
        title="下发详情"
        v-model="modal2"
        width="80%"
        class-name="vertical-center-modal">
        <Table :columns="recordColumn" :data="queryRecordData" border ref="recordTable"></Table>
      </Modal>
      <RollbackOrder ref="manualOrder" @success="manualOrderSuccess"/>
    </div>
    <Modal
      v-model="showWriteOffModel"
      title="核销详情"
      width="50%"
      @on-ok="showWriteOffModel = false"
      @on-cancel="showWriteOffModel = false">
      <Table :columns="writeColumn" :data="writeData"></Table>
    </Modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import api from '../../api'
import ExportFile from '../../components/common/ExportFile'
import OrderStatus from '@/components/order/OrderStatus.vue'
import RollbackOrder from '@/components/order/RollBackOrder.vue'
import utils from "@/utils";

export default {
  components: {
    ExportFile,
    OrderStatus,
    RollbackOrder
  },
  props: {
    isCom: {
      default: false,
      type: Boolean
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      writeData: [],
      showWriteOffModel: false,
      queryRecordData: [],
      selectList: [],
      modal2: false,
      formValidate: {
        tradeNo: null, // 平台订单号
        outTradeNo: null, // 代理商订单号
        account: null, // 用户
        agentId: null, // 代理商ID
        commodityName: null, // 商品名称
        commodityId: null, // 商品编号
        commodityNo: null, // 供应商商品编号
        agentCommodityId: null, // 代理商商品编号
        agentName: null, // 代理商名称
        rechargeType: null, // 商品类型
        nodeState: null, // 发券状态
        notifyState: null, // 核销状态
        sendingEndDate: null, // 发券时间开始
        sendingStartDate: null, // 发券时间结束
        usageEndDate: null, // 核销时间开始
        usageStartDate: null// 核销时间结束
      },
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      sendingData: [], // 发券开始结束时间
      usageData: [], // 核销开始结束时间
      supplierList: [], // 供应商下拉
      agentList: [] // 代理商下拉
    }
  },
  filters: {
    formatTime(timestamp) {
      const date = new Date(+timestamp)
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      const hours = ('0' + date.getHours()).slice(-2)
      const minutes = ('0' + date.getMinutes()).slice(-2)
      const seconds = ('0' + date.getSeconds()).slice(-2)
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    }
  },
  computed: {
    ...mapGetters(
      'recharge',
      ['rechargeType', 'rechargeMethodByValue', 'rechargeStatus', 'nodeState', 'notifyState']),

    writeColumn() {
      return [
        {
          title: '核销流水号',
          key: 'tradeId',
          width: 180
        },
        {
          title: '核销内容',
          key: 'content',
          minWidth: 280
        },
        {
          title: '核销时间',
          key: 'usedDate',
          width: 120
        },
        {
          title: '核销金额',
          key: 'amount',
          minWidth: 100
        },
        {
          title: '创建时间',
          key: 'createdDate',
          width: 160
        }]
    },
    comColumn() {
      return [
        {
          title: '供应商商品编号',
          key: 'commodityNo',
          align: 'center',
          minWidth: 150
        },
        {
          title: '用户',
          key: 'account',
          align: 'center',
          minWidth: 150
        },
        {
          title: '供应商',
          key: 'supplierName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '发券状态',
          key: 'nodeState',
          minWidth: 150,
          align: 'center',
          slot: 'couponsStatus'
        },
        {
          title: '商品编号',
          key: 'commodityId',
          align: 'center',
          minWidth: 150
        },
        {
          title: '发券时间',
          key: 'createDate',
          align: 'center',
          minWidth: 190,
          slot: 'couponsTime'
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 120,
          slot: 'action',
          align: 'center'
        }
      ]
    },
    queryColumn() {
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '代理商订单号',
          key: 'agentTradeNo',
          align: 'left',
          minWidth: 200
        },
        {
          title: '用户',
          key: 'account',
          align: 'center',
          minWidth: 150
        },
        {
          title: '供应商',
          key: 'supplierName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '商品名称',
          key: 'commodityName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '发券状态',
          key: 'nodeState',
          minWidth: 150,
          align: 'center',
          slot: 'couponsStatus'
        },
        {
          title: '商品编号',
          key: 'commodityId',
          align: 'center',
          minWidth: 150
        },
        {
          title: '供应商商品编号',
          key: 'commodityNo',
          align: 'center',
          minWidth: 150
        },
        {
          title: '发券时间',
          key: 'createDate',
          align: 'center',
          minWidth: 190,
          slot: 'couponsTime'
        },
        {
          title: '核销时间',
          key: 'usageTime',
          align: 'center',
          minWidth: 190
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 180,
          slot: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [

              params.row.nodeState === -1 ? h('Button', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.writeOffInfoHandler(params.row)
                  }
                }
              }, '核销记录') : '',
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.manualOrder(params.row)
                  }
                }
              }, '补发'),
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.openDetails(params.row)
                  }
                }
              }, '下发记录')
            ])
          }
        }
      ]
    },
    recordColumn() {
      return [
        {
          title: '请求ID',
          key: 'id',
          align: 'left',
          minWidth: 100
        },
        {
          title: '请求参数',
          key: 'reqParams',
          align: 'center',
          minWidth: 300,
          tooltip: true
        },
        {
          title: '返回参数',
          key: 'respParams',
          align: 'center',
          tooltip: true,
          minWidth: 300
        },
        {
          title: '请求时间',
          key: 'reqTime',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            return h('span', utils.formatDateTime(params.row.reqTime))
          }
        },
        {
          title: '请求耗时',
          key: 'respTime',
          align: 'center',
          minWidth: 50
        }
      ]
    }
  },
  watch: {
    sendingData(val) {
      this.formValidate.sendingStartDate = val[0] ? val[0].getTime() : null
      this.formValidate.sendingEndDate = val[1] ? val[1].getTime() : null
    },
    usageData(val) {
      this.formValidate.usageStartDate = val[0] ? val[0].getTime() : null
      this.formValidate.usageEndDate = val[1] ? val[1].getTime() : null
    }
  },
  methods: {
    writeOffInfoHandler(row) {
      api.order.writeOffInfo({id: row.id}).then(res => {
        this.writeData = res.data
        this.showWriteOffModel = true
      })
    },
    selectChangeHandler(selected) {
      this.selectList = selected
    },
    openDetails(row) {
      this.modal2 = true
      api.order.orderItemRecordList({orderId: row.id}).then(res => {
        this.queryRecordData = res.data
      })
    },
    handleSpan({row, column, rowIndex, columnIndex}) {
      let that = this
      // 因为日期在第一项，从0开始判断columnIndex === 0合并第一列
      if (columnIndex === 1) {
        let idName = that.queryData[rowIndex]?.agentTradeNo
        // rowIndex是行索引，判定第二行是不是和前面一行的日期值相同
        if (rowIndex > 0) {
          if (that.queryData[rowIndex]?.agentTradeNo !== that.queryData[rowIndex - 1]?.agentTradeNo) {
            let i = rowIndex
            let num = 0
            // 遍历
            while (i < that.queryData.length) {
              if (that.queryData[i]?.agentTradeNo === idName) {
                i++
                num++
              } else {
                i = that.queryData.length
              }
            }
            return {
              // 这里返回的num就是有相同的行数
              rowspan: num,
              // 合并几列,实例中只是跨行合并,不跨列合并,所以用的1
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        } else {
          let i = rowIndex
          let num = 0
          while (i < that.queryData.length) {
            if (that.queryData[i].agentTradeNo === idName) {
              i++
              num++
            } else {
              i = that.queryData.length
            }
          }
          return {
            rowspan: num,
            colspan: 1
          }
        }
      }
    },
    formatTime1(timestamp) {
      const date = new Date(timestamp)
      return date.toLocaleString()
    },
    formSubmit() {
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset() {
      this.$refs['formValidate'].resetFields()
      this.sendingData.splice(0)
      this.usageData.splice(0)
      this.$nextTick(() => {
        this.formSubmit()
      })
    },
    getData(orderId) {
      this.loading = true
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          const element = this.formValidate[item]
          if (element !== '' && element !== null) {
            params[item] = this.formValidate[item]
          }
        }
      }
      params.pageNum = this.pageNum
      params.pageSize = this.pageSize
      if (this.isCom) {
        params.batchId = orderId || this.orderId
      }
      api.order.orderItemList({
        ...params
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records.map(record => {
            Object.keys(record).forEach(e => {
              if (record[e] === '1970-01-01 08:00:00') record[e] = ''
            })
            return record
          }) || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取订单列表失败: ' + err.message)
        })
    },
    pageChange(pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 导出
    exportOrder() {
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          if (this.formValidate[item] !== '' && this.formValidate[item] !== null) {
            params[item] = this.formValidate[item]
          }
        }
      }
      params.pageNum = 1
      params.pageSize = 10
      this.$refs.exportFile.submit(api.order.outQueryOrder, 'get', {
        ...params
      })
    },
    // 手动购买
    manualOrder(item) {
      let items = []
      if (item) {
        items.push(item)
      } else {
        items = this.selectList;
      }
      this.$refs.manualOrder.show(items)
    },
    // 购买成功
    manualOrderSuccess() {
      this.getData()
    }
  },
  created() {
    this.getData()
    // 获取供应商数据改造成下拉数据
    api.supplier.supplierList({
      pageNum: 1,
      pageSize: 100
    }).then((res) => {
      this.supplierList = res.data.records.map(item => ({
        value: item.id,
        label: item.name
      })) || []
    }).catch((err) => {
      this.$Message.error('获取供应商列表失败: ' + err.message)
    })
    // 获取代理商数据改造成下拉数据
    api.agent.agentList({
      pageNum: 1,
      pageSize: 100
    })
      .then((res) => {
        this.agentList = res.data.records
          .map(item => ({
            value: item.id,
            label: item.agentName
          })) || []
      })
      .catch((err) => {
        this.$Message.error('获取代理商列表失败: ' + err.message)
      })
  }
}
</script>

<style>

.ivu-table-body .ivu-table-cell {
  white-space: nowrap;
}
</style>
